import { currentDomain, localeData } from 'frontend-resources/js/Helpers/Locales';

const currencyForDomain = {
    'scribbr.com': 'USD',
    'scribbr.co.uk': 'GBP',
    'scribbr.no': 'NOK',
    'scribbr.dk': 'DKK',
    'scribbr.nl': 'EUR',
    'scribbr.fi': 'EUR',
    'scribbr.fr': 'EUR',
    'scribbr.de': 'EUR',
    'scribbr.it': 'EUR',
    'scribbr.es': 'EUR',
    'scribbr.se': 'SEK',
    'scribbr.at': 'EUR',
    'scribbr.ch': 'CHF',
};

export default function ({ store }) {
    let domain = currentDomain();

    if (store.user && store.user.locale && localeData[store.user.locale]) {
        domain = localeData[store.user.locale];
    }

    store.currency = currencyForDomain[domain] || 'USD';
    store.domain = domain;
}
